import axios from "axios";
import {Base_URL} from "../url"

export const fetchCustomerMaster = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CustomerMaster/CustomerGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer master data!";
  }
};
export const fetchCustomerMasterByOrgId = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/CustomerMaster/CustomerGetData/id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer master data!";
  }
};
export const downloadCustomerDataExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CustomerMaster/DownloadCustomerDataExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading customer data!";
  }
};